import { If } from 'aa_common/front-end/components'
import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { Col, Row } from 'antd'
import { DEPRECIATION_METHOD_CODE } from 'common/constants'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'
import { useFormContext } from 'react-hook-form'

import { useGetAssetLedger } from '../hooks/use-get-asset-ledger'
import { useIsFullImpairment } from '../hooks/use-is-full-impairment'
import { useResidualServiceLifeDefault } from '../hooks/use-residual-service-life-default'
import { SmallInputClass } from '../styles'
import { FIELD_NAMES } from '../validation'

const { FormField } = Form

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])

const FieldName = FIELD_NAMES.impair_service_life

type ResidualServiceLifeProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ResidualServiceLife = ({ ledgerSetting }: ResidualServiceLifeProps) => {
  useNsReady()
  const { setValue } = useFormContext()
  const assetLedger = useGetAssetLedger(ledgerSetting)
  const shouldShow =
    assetLedger?.depreciation_method_code &&
    ![DEPRECIATION_METHOD_CODE.AVERAGE_USAGE_PERIOD, DEPRECIATION_METHOD_CODE.LEASE_PERIOD_STRAIGHT_LINE].includes(
      assetLedger.depreciation_method_code
    )
  const disabled = useIsFullImpairment()
  const defaultValue = useResidualServiceLifeDefault(assetLedger?.service_life)

  useNextEffect(() => {
    !shouldShow && setValue(FieldName, null)
  }, [setValue, shouldShow])
  useNextEffect(() => {
    shouldShow && !disabled && setValue(FieldName, defaultValue)
    shouldShow && disabled && setValue(FieldName, null)
  }, [shouldShow, disabled, setValue, defaultValue])

  return (
    <If condition={shouldShow}>
      <FormField title={t('residual_service_life')} required>
        <Row align="middle" gutter={8}>
          <Col>
            <InputNumber min={1} name={FieldName} disabled={disabled} className={SmallInputClass} controls={false} />
          </Col>
          <Col>
            <span>{t('residual_service_life_unit')}</span>
          </Col>
        </Row>
      </FormField>
    </If>
  )
}
